
import { Options, Vue } from 'vue-class-component';

@Options({
    components: {
    },
    props: {
       restorant: {
           type: Object,
           required: true
       }
    }
})
export default class RestorantMarker extends Vue {
    restorant!:any;
   

}


